<template>
  <div :class="$vuetify.breakpoint.smAndUp ? 'py-7 px-7' : ''">
    <video-detail></video-detail>
  </div>
</template>
<script>
export default {
  name: "VideoDetailPage",
  components: {
    VideoDetail: () => import("./VideoDetail/VideoDetail.vue"),
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    user_id() {
      return this.$route.query.usid;
    },
    playlist_id() {
      return this.$route.query.ptid;
    },
    video_id() {
      return this.$route.query.id;
    },
    playlist_video() {
      return this.$route.query.vdid;
    },
    play_type() {
      return this.$route.query.type;
    },
  },
  watch: {},
  methods: {},
  mounted() {},
  created() {},
};
</script>
